// src/components/Header.jsx
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./Header.css";

const Header = ({ rol, handleLogout }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogoutAndRedirect = () => {
    handleLogout();
    navigate("/landing");
  };

  return (
    <header className="header">
      <nav className="navbar navbar-expand-lg navbar-dark bg-darkblue">
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">

              {/* ───────────  ADMINISTRADOR ─────────── */}
              {rol === 'Administrador' && (
                <>
                  <li className="nav-item">
                    <Link className="nav-link" to="/control-produccion">
                      Control de Producción Diario
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/dashboard">
                      Ruta de Transportes
                    </Link>
                  </li>

                  {/* Pedidos */}
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="navbarPedidos"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Pedidos
                    </a>
                    <ul className="dropdown-menu" aria-labelledby="navbarPedidos">
                      <li><Link className="dropdown-item" to="/pedidos">Todos los pedidos</Link></li>
                      <li><Link className="dropdown-item" to="/nuevo-pedido">Nuevo pedido</Link></li>
                      <li><Link className="dropdown-item" to="/totales-para-servir">Totales Para Servir</Link></li>
                      <li><Link className="dropdown-item" to="/graficas-pedidos">Analítica de pedidos</Link></li>
                      <li><Link className="dropdown-item" to="/dias-sin-reparto">Días sin reparto</Link></li>
                    </ul>
                  </li>

                  {/* Renting */}
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="navbarRenting"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Renting
                    </a>
                    <ul className="dropdown-menu" aria-labelledby="navbarRenting">
                      <li><Link className="dropdown-item" to="/ropa_cliente">Control de ropa por cliente</Link></li>
                      <li><Link className="dropdown-item" to="/compras_reposición">Compras para reposición</Link></li>
                      <li><Link className="dropdown-item" to="/almacen">Reposición de almacén</Link></li>
                      <li><Link className="dropdown-item" to="/entradas_salidas">Entradas y salidas de kilos</Link></li>
                    </ul>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link" to="/totales-mes">
                      Informes de Kilos
                    </Link>
                  </li>

                  {/* Administración */}
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="navbarAdmin"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Administración
                    </a>
                    <ul className="dropdown-menu" aria-labelledby="navbarAdmin">
                      <li><Link className="dropdown-item" to="/clientes">Clientes</Link></li>
                      <li><Link className="dropdown-item" to="/empleados">Transportistas</Link></li>
                      <li><Link className="dropdown-item" to="/usuarios">Accesos internos</Link></li>
                      <li><Link className="dropdown-item" to="/vehiculos">Vehículos</Link></li>
                      <li><Link className="dropdown-item" to="/ropa">Prendas</Link></li>
                    </ul>
                  </li>
                </>
              )}

              {/* ───────────  ENCARGADO ─────────── */}
              {rol === 'Encargado' && (
                <>
                  <li className="nav-item">
                    <Link className="nav-link" to="/control-produccion">
                      Control de Producción Diario
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/dashboard">
                      Ruta de Transportes
                    </Link>
                  </li>

                  {/* Pedidos */}
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="navbarPedidosEnc"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Pedidos
                    </a>
                    <ul className="dropdown-menu" aria-labelledby="navbarPedidosEnc">
                      <li><Link className="dropdown-item" to="/pedidos">Todos los pedidos</Link></li>
                      <li><Link className="dropdown-item" to="/nuevo-pedido">Nuevo pedido</Link></li>
                      <li><Link className="dropdown-item" to="/totales-para-servir">Totales Para Servir</Link></li>
                      <li><Link className="dropdown-item" to="/graficas-pedidos">Analítica de pedidos</Link></li>
                      <li><Link className="dropdown-item" to="/dias-sin-reparto">Días sin reparto</Link></li>
                    </ul>
                  </li>
                </>
              )}

              {/* ───────────  CLIENTE ─────────── */}
              {rol === 'Cliente' && (
                <>
                  <li className="nav-item">
                    <Link className="nav-link" to="/cliente-pedidos">
                      Nuevo pedido
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/cliente-historico-pedidos">
                      Histórico de pedidos
                    </Link>
                  </li>
                </>
              )}

              {/* ───────────  EMPLEADO (sin menú extra) ─────────── */}
            </ul>
          </div>

          {/* perfil / logout */}
          <div className="profile-section d-flex align-items-center">
            <img
              src="/images/perfil.png"
              alt="Profile"
              className="profile-image"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            />
            <ul className="dropdown-menu dropdown-menu-end">
              <li>
                <button className="dropdown-item" onClick={handleLogoutAndRedirect}>
                  Cerrar sesión
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <style>{`
        .profile-image { cursor:pointer; width:40px; height:40px; border-radius:50%; }
        .bg-darkblue   { background:#0d1b2a; }            /* tu color corporativo */
      `}</style>
    </header>
  );
};

export default Header;
